// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css';
import _ from 'lodash'
import * as filters from './utils/filters'
import "@/core/use_vant";
import "@/api/api_request";
import { GetQueryString } from "@/utils/utils";
import { loginWithReferer } from "@/utils/referer";
import { login, getClient } from "@/api/api";

Vue.use(ElementUI);

var app_id = 1

Vue.prototype.app_id = app_id
Vue.prototype.$is_mobile = navigator.userAgent.toLowerCase().match(
    /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
  ) != null;
Object.keys(filters).forEach(key => {         // 注册全局过滤器
  Vue.filter(key, filters[key])
})

store.commit('setToken')

Vue.config.productionTip = false
// 格式化气体数值方法
Vue.prototype.$sensortypeRound = colorIntensity.sensortypeRound;

var img_url='http://jnwzhuabei2.oss-cn-beijing.aliyuncs.com/yanggu_logs/'
Vue.prototype.img_url = img_url

let hideBackBtn = GetQueryString('hideBackBtn');
if (!!hideBackBtn) {
  store.commit("setHideBackBtn", true)
}

const run_app = function() {
  new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
  })  
}

async function init () {
  let loginType = GetQueryString('loginType')
  if (loginType == 'referer') {
    await loginWithReferer(store)
  } else if (loginType == 'wx') {
    localStorage.setItem("u_username", "jnwater");
    let c = await getClient("jnwater");
    store.commit("setClientInfo", c.data.data);
    let data = {
      username: "jnwater",
      password: "8259481",
      grant_type: "password",
      client_id: c.data.data.clientId,
      client_secret: c.data.data.clientSecretStr
    };
    let d = await login(data);
    let token = d.data.access_token;
    store.commit("setToken", token);
    localStorage.setItem("yc_token", token);
  }
  store.dispatch("init", (status) => {
    status && router.replace({ name: "index" });
  });
  run_app()
}
init()



// WEBPACK FOOTER //
// ./src/main.js